module.exports = __webpack_public_path__ + "static/media/lower.2a0f49bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/lower.svg
// module id = 1067
// module chunks = 0